
import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import { clone } from 'lodash';
import { CardValidation } from "@/store/rules-engine/types";
import { namespace } from "vuex-class";

const RuleStore = namespace('rulesEngine');

@Component({})
export default class RulesTimeDurationInput extends Vue {
    @Prop({type: [String, Number]})
    private value: number | string;

	@Prop({type: String})
    private placeholderTextMinutes: string;

	@Prop({type: String})
    private placeholderTextSeconds: string;

	@Prop({type: Number})
    private minValue: number;

	@Prop({type: Number})
    private maxValue: number;

	@Prop({type: Boolean})
	private allowDecimal: boolean;

	@Prop({type: Boolean})
	private allowNulls: boolean;

	@Prop({type: Boolean})
	private readOnly: boolean;

	@Prop({type: String})
	private dataCyForMinutes: string;

	@Prop({type: String})
	private dataCyForSeconds: string;

	private inputNumberMinutes: string = null;
    private inputNumberSeconds: string = null;

	private minMinutesValue: number = null;
	private maxMinutesValue: number = null;
	private minSecondsValue: number = null;
	private maxSecondsValue: number = null;

	private inputValidation: CardValidation = { isValid: false, message: ""};

	private readonly secondsPerMinute: number = 60;

    private mounted(): void {
		this.setRangesFromSeconds();
        this.valueUpdate();
    }

	private checkValueType(): number {
		if (typeof this.value === "string") {
			return parseInt(this.value);
		} else {
			return clone(this.value);
		}
	}

	private totalSeconds(): number {
		let minutes = this.inputNumberMinutes ? parseInt(this.inputNumberMinutes) : 0;
		let seconds = this.inputNumberSeconds ? parseInt(this.inputNumberSeconds) : 0;
		return (minutes * this.secondsPerMinute) + seconds;
	}

	@Watch("inputNumberMinutes")
	@Watch("inputNumberSeconds")
	@Emit("input")
    private valueUpdated(value: string): number
    {
        this.validateInput();
        return value ? this.totalSeconds() : null;
    }

    @Watch("value")
    private valueUpdate(): void
    {
		if (this.maxMinutesValue > 0) {
			this.inputNumberMinutes = this.value ? Math.floor(this.checkValueType() / this.secondsPerMinute).toString() : null;
		}

		this.inputNumberSeconds = this.value ? (this.checkValueType() % this.secondsPerMinute).toString() : null;

        this.validateInput();
    }

	@Emit("isValid")
    private validateInput(): CardValidation
    {
		let totalSeconds = this.totalSeconds();

		if (this.allowNulls && this.inputNumberMinutes?.length < 1 && this.inputNumberSeconds?.length < 1) {
			this.inputValidation.isValid = true;
		}
		else if (totalSeconds < this.minValue)
		{
			this.inputValidation.isValid = false;
			this.inputValidation.message = `*Duration must be greater than or equal to ${this.minValue} seconds`;
		}
		else if (totalSeconds > this.maxValue)
		{
			this.inputValidation.isValid = false;
			this.inputValidation.message = `*Duration must be less than or equal to ${this.maxValue} seconds`;
		}
		else
		{
			this.inputValidation.isValid = true;
		}

		return this.inputValidation;
	}

	@Watch("maxValue")
	private setRangesFromSeconds(): void {
		this.minSecondsValue = 0;
		this.maxSecondsValue = Math.min(this.maxValue, this.secondsPerMinute);

		this.minMinutesValue = 0;
		this.maxMinutesValue = Math.floor(this.maxValue / this.secondsPerMinute);
	}

	private numberInputSecondsFormatter(value): number {
		if (value < this.minSecondsValue || value > this.maxSecondsValue) {
			return null;
		}

		return value;
	}

	private numberInputMinutesFormatter(value): number {
		if (value < this.minMinutesValue || value > this.maxMinutesValue) {
			return null;
		}

		return value;
	}
}
